module.exports = __webpack_public_path__ + "img/olympiakos-piraeus-logo-icon.ead3bd56.png";